import type { ActorRole, CardDeck, GameCard, GameMode, PenetrationLevel, SessionSummary } from "../types";

export function actorName(actor: ActorRole, husbandName: string, wifeName: string): string {
  if (actor === "husband") return husbandName || "Suami";
  if (actor === "wife") return wifeName || "Istri";
  return "Kalian";
}

export function deckLabel(deck: CardDeck, husbandName = "Suami", wifeName = "Istri"): string {
  if (deck === "talks") return "Talks";
  if (deck === "foreplay_husband") return `Foreplay by ${husbandName || "Suami"}`;
  if (deck === "foreplay_wife") return `Foreplay by ${wifeName || "Istri"}`;
  return "Penetrasi";
}

export function modeLabel(mode: GameMode, husbandName = "Suami", wifeName = "Istri"): string {
  return deckLabel(mode, husbandName, wifeName);
}

export function levelLabel(level?: PenetrationLevel): string {
  if (level === "normal") return "Normal";
  if (level === "hard") return "Hard";
  if (level === "extreme") return "Extreme";
  return "Pilih Level";
}

export function cardTypeLabel(card: GameCard): string {
  if (card.deck === "talks") return "Question Card";
  if (card.deck === "penetration") return `${levelLabel(card.level)} Position`;
  return "Action Card";
}

export function cardHeading(card: GameCard, husbandName: string, wifeName: string): string {
  if (card.title) return renderPersonalizedText(card.title, husbandName, wifeName);
  if (card.deck === "penetration") return "Penetrasi";
  return `${actorName(card.actor, husbandName, wifeName)}’s Turn`;
}

export function cardSubheading(card: GameCard, husbandName: string, wifeName: string): string {
  if (card.deck === "talks") return `${actorName(card.actor, husbandName, wifeName)}’s Turn`;
  if (card.deck === "foreplay_husband") return `${husbandName || "Suami"}’s Turn`;
  if (card.deck === "foreplay_wife") return `${wifeName || "Istri"}’s Turn`;
  return levelLabel(card.level);
}

export function renderPersonalizedText(text: string, husbandName: string, wifeName: string): string {
  return text
    .replace(/\[nama suami\]/gi, husbandName || "suami")
    .replace(/\[nama istri\]/gi, wifeName || "istri");
}

export function finalStatusLabel(status: SessionSummary["finalStatus"]): string {
  if (status === "completed") return "selesai semua kartu";
  return "diakhiri";
}

export function formatSessionDuration(startedAt: string, endedAt: string): string {
  const minutes = Math.max(1, Math.round((Date.parse(endedAt) - Date.parse(startedAt)) / 60000));
  if (minutes < 60) return `${minutes} menit`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `${hours} jam ${rest} menit` : `${hours} jam`;
}
